import React from "react";
import CreateAccountForm from "components/create-account-form";
import { userLoginToken } from "utils/general-utils";
import styles from "./update.module.css";

interface Props {
  firstName: string;
  lastName: string;
  listNames: string[];
  removedListNames: string[];
  hasAccount: boolean;
  requestCode: string;
  primaryEmail?: string;
  primaryMobilePhone?: string;
}

const enumerateLists = (lists:string[]):string => {
  const len = lists.length;
  if (len < 1) return "the list";
  if (len < 2) return `the ${lists[0]} list`;

  return `the ${lists.slice(0, len - 1).join(", ")}${len > 2 ? "," : ""} and ${lists[len - 1]} lists`;
};

const SuccessView: React.FC<Props> = ({
  firstName,
  lastName,
  listNames,
  removedListNames,
  hasAccount,
  requestCode,
  primaryEmail,
  primaryMobilePhone,
}) => (
  <>
    <div className={styles.success}>
      <h1>🎉 Thanks{firstName && `, ${firstName}`}!</h1>
      We’ve updated your application, and your spot on {enumerateLists(listNames)} is safe.
      {removedListNames.length > 0 ? ` You've also been removed from ${enumerateLists(removedListNames)}. ` : "" }
      No further action is needed, and you will not be contacted until you are at the
      top of the list. Thanks!
    </div>

    {!hasAccount && !userLoginToken() && (
      <div className="card margin-top-m">
        <h2>Create Your Account</h2>

        <p>
          By creating an account, you can use reuse your information across all housing
          applications within Haven Connect.
        </p>

        <p className={styles.signupMethodContext}>
          By providing both an email and phone number, you can login to your account using either
          method.
        </p>

        <div className="margin-top-m" style={{ maxWidth: 300 }}>
          <CreateAccountForm
            firstName={firstName}
            lastName={lastName}
            email={primaryEmail}
            phone={primaryMobilePhone}
            requestCode={requestCode}
          />
        </div>
      </div>
    )}
  </>
);
export default SuccessView;
